import moment, { Moment } from 'moment-timezone';
import { IRootState } from './type';

const initialState: IRootState = {
  shopifyOrders: [],
  attributedOrders: [],
  mainDate: moment().format(),
  weeklyChart: [],
  selectedLocationId: 0,
  isOrdersLoading: true,
  filteredOrders: [],
  ordersMapping: [],
  dailyStateSelectedLocation: 0,
  dailyStatesData: {} as IRootState['dailyStatesData'],
  orderCounts: 0,
  ordersChosenDates: [] as unknown as [Moment, Moment],
  employeeRates: {} as IRootState['employeeRates'],
  channelData: {} as IRootState['channelData'],
  ordersTotals: {} as IRootState['ordersTotals'],
  locationStats: [],
  salesmanStats: {} as IRootState['salesmanStats'],
  ordersByDates: [],
  ordersByLocations: {} as IRootState['ordersByLocations'],
  dataByMemberAndLocation: {},
  locationMetrics: {} as IRootState['locationMetrics'],
  dorChosenDate: '',
  selectedOrder: {} as IRootState['selectedOrder'],
  cameFromProductExchanges: false,
  variantExchangeResult: {} as IRootState['variantExchangeResult'],
  promotersTotals: [],
  menuOptionName: '',
};

export {
  initialState,
};
